module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1b25f57863d78566f7c430953d5498da.png";